import { t } from 'i18next';
import { Text, TextLink } from '@oliasoft-open-source/react-ui-library';

import translations from 'client/internationalization/translation-map.json';
import { SecurityClassification, INode, IObject } from 'common/interfaces/hierarchy-entities';
import { getIsLinked } from 'common/utils/is-linkable-table';
import { IUser } from 'common/interfaces/customer-interfaces';
import { resolveAssociatedDataName } from 'common/services/configs/trajectories/associated-data/associated-data-name-resolver';
import { getDataIsEmpty } from 'common/utils/get-data-is-empty';

export const getRestrictedName = (item: IObject | INode, companyName: string, owner: IUser) => {
  const { name } = item;
  const restrictedText = item.classificationlevel === SecurityClassification.INTERNAL ? t(translations.authorization_is_internal, { name, companyName }) : t(translations.authorization_is_restricted, { name, companyName });

  return (
    <Text faint>
      {restrictedText}
      <TextLink target="_blank" href={`mailto:${owner?.email}`}>
        [
        {t(translations.authorization_request_access)}
        ]
      </TextLink>
    </Text>
  );
};

export const getObjectName = (object: IObject, associatedData: any = {}, companyName?: string, owner?: IUser) => {
  const name = resolveAssociatedDataName(object, associatedData);
  if (object.restricted && companyName && owner) {
    return getRestrictedName(object, companyName, owner);
  }
  if (object.data) {
    const { isLinked } = getIsLinked(object);
    return <Text faint={getDataIsEmpty(object.data, isLinked)}>{name}</Text>;
  }

  return name || object.metadata?.file?.name;
};
